import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import { getLanguage } from '@/utils/localstorage';

Vue.use(VueI18n);

function loadLocaleMessages(): LocaleMessages {
  const locales = require.context('@/lang', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages: LocaleMessages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const messages = loadLocaleMessages();

export const getLocale = () => {
  const savedLanguage = getLanguage();
  if (savedLanguage) {
    return savedLanguage;
  }

  // uncomment if want to support browser language
  // const language = navigator.language.toLowerCase();
  // const locales = Object.keys(messages);
  // for (const locale of locales) {
  //   if (language.indexOf(locale) > -1) {
  //     return locale;
  //   }
  // }

  // Default language is english
  return process.env.VUE_APP_I18N_LOCALE || 'en';
};

export default new VueI18n({
  locale: getLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: messages,
});
